import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tx-narrow" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "tx-field" }
const _hoisted_5 = {
  key: 0,
  class: "tx-suggest",
  "aria-live": "polite"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "tx-formrow" }
const _hoisted_8 = {
  key: 0,
  class: "tx-field"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "—", -1 /* HOISTED */)
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 1,
  class: "tx-field"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "—", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "tx-field" }
const _hoisted_15 = {
  key: 1,
  class: "tx-error",
  role: "alert"
}
const _hoisted_16 = { class: "tx-formactions" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("a", {
      href: $setup.link('tickets'),
      "data-nav": "",
      class: "tx-backlink"
    }, [
      _createVNode($setup["Icon"], {
        name: "back",
        size: "16"
      }),
      _createTextVNode(_toDisplayString($setup.state.t("tickets.title")), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("h1", null, _toDisplayString($setup.state.t("tickets.new")), 1 /* TEXT */),
    _createElementVNode("form", {
      class: "tx-card tx-form",
      onSubmit: _withModifiers($setup.submit, ["prevent"])
    }, [
      _createElementVNode("label", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString($setup.state.t("tickets.subject")), 1 /* TEXT */),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.subject) = $event)),
          required: "",
          minlength: "3",
          maxlength: "140",
          autocomplete: "off",
          onInput: $setup.suggest
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelText, $setup.subject]
        ])
      ]),
      ($setup.suggestions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _createVNode($setup["Icon"], {
                name: "book",
                size: "16"
              }),
              _createTextVNode(_toDisplayString($setup.state.t("tickets.suggested")), 1 /* TEXT */)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.suggestions, (a) => {
              return (_openBlock(), _createElementBlock("a", {
                key: a.name,
                href: $setup.link('knowledge/' + a.name),
                target: "_blank",
                rel: "noopener"
              }, _toDisplayString(a.title), 9 /* TEXT, PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_7, [
        ($setup.opts.ticket_types.length)
          ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString($setup.state.t("tickets.type")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.ticketType) = $event))
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.opts.ticket_types, (t) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: t,
                    value: t
                  }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_10))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.ticketType]
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.opts.priorities.length)
          ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString($setup.state.t("tickets.priority")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.priority) = $event))
              }, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.opts.priorities, (p) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: p,
                    value: p
                  }, _toDisplayString(p), 9 /* TEXT, PROPS */, _hoisted_13))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.priority]
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("label", _hoisted_14, [
        _createElementVNode("span", null, _toDisplayString($setup.state.t("tickets.description")), 1 /* TEXT */),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.description) = $event)),
          rows: "8",
          required: "",
          maxlength: "20000"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.description]
        ])
      ]),
      _createVNode($setup["FilePicker"], {
        modelValue: $setup.files,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.files) = $event))
      }, null, 8 /* PROPS */, ["modelValue"]),
      ($setup.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.error), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("a", {
          href: $setup.link('tickets'),
          "data-nav": "",
          class: "tx-btn tx-btn--ghost"
        }, _toDisplayString($setup.state.t("common.cancel")), 9 /* TEXT, PROPS */, _hoisted_17),
        _createElementVNode("button", {
          class: "tx-btn tx-btn--primary",
          disabled: $setup.busy
        }, _toDisplayString($setup.state.t("tickets.create")), 9 /* TEXT, PROPS */, _hoisted_18)
      ])
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3)
  ]))
}